<div class="chat_box" *ngIf="isShowChat" (click)="$event.stopPropagation()">
    <div class="head">
        <div class="user">
            <div class="avatar">
                <img src="../../../assets/images/ailens.png" alt="AI Assistant" />
            </div>
            <div class="name">AI Assistant</div>
        </div>
        <ul class="bar_tool">
            <li><span (click)="closeChat()" class="alink"><i class="fas fa-times"></i></span></li>
        </ul>
    </div>
    <div class="body">
        <div [ngClass]="message.sender == 'AiAssistant'?'incoming':'outgoing'" *ngFor="let message of messageList">
            <div class="bubble">
                <markdown>{{message.message}}</markdown>
            </div>
        </div>
        
        <div class="typing" *ngIf="showBotLoader">
            <div [ngClass]="isTranscribing ? 'transcribing-word' : 'thinking-word'">{{randomThinkingWord}}</div>
        </div>
    </div>
    <div class="foot" [ngClass]="{'speaking': isAiSpeaking}">
        <input type="text" [disabled]="isRecording" (keydown)="onKeyDown($event)" [(ngModel)]="message" class="msg" 
               [placeholder]="isRecording ? 'Recording! stop to send' : 'Type your message...'" />
        <div class="recording-wave" *ngIf="isRecording">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="button-container">
            <button class="voice-button" 
                    [ngClass]="{'recording': isRecording, 'speaking': isAiSpeaking}" 
                    (click)="isRecording ? startRecording() : (isAiSpeaking ? stopSpeaking() : startRecording())" 
                    [title]="isRecording ? 'Stop recording' : (isAiSpeaking ? 'Stop AI speaking' : 'Voice input')">
                <i class="fas" 
                   [ngClass]="isRecording ? 'fa-stop-circle' : (isAiSpeaking ? 'fa-volume-mute' : 'fa-microphone-alt')"></i>
            </button>
            <button class="send-button" type="submit" (click)="sendMessage()" title="Send message">
                <i class="fas fa-paper-plane"></i>
            </button>
        </div>
    </div>
</div>

<div class="chat-icon" *ngIf="!isShowChat" (click)="openChat($event)">
    <span>Chat with AI</span>
    <i class="fas fa-robot"></i>
</div>